import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { REST_ENPOINTS } from "../../../constants/enpoints";

const initialState = {
  updateForm: { id: null, nickname: "" },
  file: "",
  uploadPreview: null,
  uploadLoading: false,
  uploadError: null,
  isOpenBotModal: false,
};

export const uploadBotProfileImage = createAsyncThunk(
  "bot/upload",
  async (args, thunkAPI) => {
    const { file } = thunkAPI.getState().bot;
    try {
      const res = await axios.post(REST_ENPOINTS.uploadBotProfileImage, {
        file,
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const botSlice = createSlice({
  name: "bot",
  initialState,
  reducers: {
    onChangeBotForm: (state, { payload }) => {
      state.updateForm = {
        ...state.updateForm,
        nickname: payload.nickname,
      };
    },
    setBotImageFile: (state, { payload }) => {
      state.file = payload;
    },
    setBotImagePreview: (state, { payload }) => {
      state.uploadPreview = payload;
    },
    setUpdateBot: (state, { payload }) => {
      state.updateForm = payload;
    },
    clearBotForm: (state) => {
      state.updateForm = initialState.updateForm;
      state.uploadPreview = initialState.uploadPreview;
      state.file = initialState.file;
    },
    removeBotImage: (state) => {
      state.uploadPreview = initialState.uploadPreview;
      state.file = initialState.file;
    },
    toggleBotModal: (state) => {
      state.isOpenBotModal = !state.isOpenBotModal;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadBotProfileImage.pending, (state) => {
        state.uploadLoading = true;
      })
      .addCase(uploadBotProfileImage.fulfilled, (state) => {
        state.uploadLoading = false;
      })
      .addCase(uploadBotProfileImage.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.payload;
      });
  },
});

export const {
  onChangeBotForm,
  setBotImageFile,
  setBotImagePreview,
  setUpdateBot,
  clearBotForm,
  removeBotImage,
  toggleBotModal,
} = botSlice.actions;

export default botSlice.reducer;
